import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const HamburgerMenuContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: inline-block;
  z-index: 1000;
`

const HamburgerIcon = styled.div`
  width: 32px;
  height: 24px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1001;
  position: relative;

  span {
    display: block;
    width: 100%;
    height: 3px;
    background-color: #fff;
    border-radius: 4px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform-origin: center;

    &:nth-child(1) {
      transform: ${({ $isOpen }) => ($isOpen ? 'translateY(10.5px) rotate(45deg)' : 'none')};
    }

    &:nth-child(2) {
      opacity: ${({ $isOpen }) => ($isOpen ? '0' : '1')};
      transform: ${({ $isOpen }) => ($isOpen ? 'translateX(10px)' : 'none')};
    }

    &:nth-child(3) {
      transform: ${({ $isOpen }) => ($isOpen ? 'translateY(-10.5px) rotate(-45deg)' : 'none')};
    }
  }

  &:hover span {
    background-color: ${({ $isOpen }) => ($isOpen ? '#fff' : '#f0f0f0')};
  }
`

const DropdownMenu = styled.ul`
  position: absolute;
  top: 40px;
  right: 0;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  list-style: none;
  padding: 8px;
  margin: 0;
  min-width: 220px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  /* Animation */
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition: opacity 0.2s ease, transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  transform-origin: top right;
`

const MenuItem = styled.li`
  padding: 12px 16px;
  margin-bottom: 2px;
  border-radius: 8px;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 1.7rem;
  font-weight: 500;
  color: #333;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background-color: #f5f7fa;
    color: #0066cc;
    transform: translateX(2px);
  }

  &:active {
    background-color: #eef1f5;
    transform: translateX(0);
  }
`

const HamburgerMenu = ({ menuItems }) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const handleItemClick = (onClick) => {
    onClick()
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <HamburgerMenuContainer ref={menuRef}>
      <HamburgerIcon onClick={toggleMenu} $isOpen={isOpen} role="button" aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </HamburgerIcon>
      <DropdownMenu $isOpen={isOpen}>
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={() => handleItemClick(item.onClick)}>
            {item.text}
          </MenuItem>
        ))}
      </DropdownMenu>
    </HamburgerMenuContainer>
  )
}

export default HamburgerMenu